'use strict';

const billingSalesLedger = {
  bindings: {
    items: '<',
    total: '<'
  },
  template: `
    <h2>Kontoutskrift</h2>

    <input type="search" ng-model="$ctrl.q" placeholder="Søk på fakturanummer eller type">

    <table>
      <thead>
        <tr>
          <th>Dato</th>
          <th>Type</th>
          <th>Fakturanummer</th>
          <th class="right-align">Debet</th>
          <th class="right-align">Kredit</th>
          <th class="right-align">Saldo</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.items | filter:$ctrl.q track by $index">
          <td>{{ item.invoiceDate | dateFormat }}</td>
          <td>{{ item.type }}</td>
          <td>
            <a ng-hide="item._links.dunnings.length" href="{{ item._links.invoice.pdf }}">{{ item.invoiceNumber }}</a>

            <a ng-show="item._links.dunnings.length" href ng-click="panel = !panel">{{ item.invoiceNumber }}</a>
            <ul ng-show="panel" class="dropdown-list">
              <li><a href="{{ item._links.invoice.pdf }}">Regning</a></li>
              <li ng-repeat="dunning in item._links.dunnings"><a href="{{ dunning.pdf }}">{{ dunning.type | documentName }}</a></li>
            </ul>
          </td>
          <td class="right-align">
            <span ng-if="item.debit != 0">{{ item.debit | crowns }}</span>
          </td>
          <td class="right-align">
            <span ng-if="item.credit != 0">{{ item.credit | crowns }}</span>
          </td>
          <td class="right-align">{{ item.balance | crowns }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="3">Total</th>
          <th class="right-align">{{ $ctrl.total.debit | crowns }}</th>
          <th class="right-align">{{ $ctrl.total.credit | crowns }}</th>
          <th class="right-align">{{ $ctrl.total.balance | crowns }}</th>
        </tr>
      </tfoot>
    </table>
  `
};

angular
  .module('SendRegning')
  .component('billingSalesLedger', billingSalesLedger);
